const api = {
  userInfoApi: '/umv1/user/info',
  langListApi: '/umv1/langs/lists',
  // courseLangsApi: '/info/course_langs_v2',
  courseLangsApi: '/studyv1/course/list', // 新的课程列表接口
  purchaseCourse: '/store/purchase_course', // 购买课程接口
  generateSignApi: '/umv1/user/anony', // 匿名登录接口
  newsIndexApi: '/web/news/index', // 新闻首页接口
  newDetailApi: '/web/news/detail', // 新闻详情接口
  newListApi: '/web/news/list' // 新闻列表
}

export default api
